import React, { Component } from "react";
import {
  Card,
  Container,
  Row,
  Col,
  Button,
  Form,
  FormControl,
  Tabs,
  Tab,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import { connect } from "react-redux";
import { PlateSearchActions, SuperAdminAction } from "../../Actions";
import { findBySearch } from "../helper";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import { SRLWrapper } from "simple-react-lightbox";
import PaginationforData from "../pagination/pagination";
import moment from "moment";

class CurrentOccupancy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPlate: [],
      currentPlateSearch: [],
      loader: false,
      plate_holder: "",
      searchValue: "",
      searchValues: "",
      searchedPlateList: [],
      PlateList: [],
      errorMsg: true,
      api_response: false,
      prevSearch: "",
      prevPage: "",
      prevNorow: "",
      prevSearchTab2: "",
      prevPageTab2: "",
      prevNorowTab2: "",
      selectedTab: "Tab1",
      tab2Page: 1,
      tab2Norow: 100,
      page: 1,
      Norow: 100,
      selectedColumn: "created_at",
      asc: "false",
      sort_direction: "DESC",
      pageChanged: false,
      ariaSelectedA: false,
      findMore: false,
      count: 0,
      count2: 0,
      timezone: this.props.timezone,
      property: this.props.property,
      lpn: "",
      isPlateApproved: "",
      image: "",
      plateData: "",
      scan_time: 0,
      lastEntry: "",
    };
    const options = {
      buttons: {
        showAutoplayButton: false,
        showCloseButton: true,
        showDownloadButton: false,
        showFullscreenButton: false,
        showNextButton: false,
        showPrevButton: false,
        showThumbnailsButton: false,
      },
      ProgressBar: {
        showProgressBar: false,
      },
      thumbnails: {
        showThumbnails: false,
      },
    };
    this.customStyles = {
      rows: {
        style: {
          minHeight: "72px", // override the row height
        },
      },
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
        },
      },
      cells: {
        style: {
          paddingLeft: "8px", // override the cell padding for data cells
          paddingRight: "8px",
        },
      },
    };

    this.columns2 = [
      {
        name: "Current Status",
        sortable: true,
        cell: (row) => (
          <div
            className="text-nowrap"
            dangerouslySetInnerHTML={{ __html: row.active }}
          ></div>
        ),
        selector: (row) => row.active,
      },
      {
        name: "Permit Class",
        sortable: true,
        cell: (row) => (
          <div dangerouslySetInnerHTML={{ __html: row.permit_class }}></div>
        ),
        selector: (row) => row.permit_class,
      },
      // {
      //   name: "Id",
      //   sortable: true,
      //   cell: (row) => <div>{row.id}</div>,
      //   selector: (row) => row.id,
      // },
      {
        name: "CreateTime",
        width: "160px",
        sortable: true,
        cell: (row) => <div>{moment(row.created_at).format("lll")}</div>,
        selector: (row) => row.created_at_date_format,
      },
      {
        name: "ModifyTime",
        width: "160px",
        sortable: true,
        cell: (row) => <div>{moment(row.updated_at).format("lll")}</div>,
        selector: (row) => row.updated_at_date_format,
      },
      {
        name: "BeginTime",
        width: "160px",
        sortable: true,
        cell: (row) => <div>{row.begin_time}</div>,
        selector: (row) => row.begin_time_date_format,
      },
      {
        name: "ExpiryTime",
        width: "160px",
        sortable: true,
        cell: (row) => <div>{row.expire_time}</div>,
        selector: (row) => row.expire_time_date_format,
      },
      {
        name: "Unit Id",
        width: "150px",
        sortable: true,
        cell: (row) => <div>{row.suite_id}</div>,
        selector: (row) => row.suite_id,
      },
      {
        name: "Lot Name",
        sortable: true,
        cell: (row) => <div>{row.lot_name}</div>,
        selector: (row) => row.lot_name,
      },
      {
        name: "LPN",
        sortable: true,
        cell: (row) => <div>{row?.lpn}</div>,
        selector: (row) => row?.lpn,
      },
      {
        name: "Deactivation Time",
        sortable: true,
        cell: (row) => (
          <div>{row.deactivated_at ? row.deactivated_at : "-"}</div>
        ),
        selector: (row) => row?.deactivated_at_date_format,
      },
      {
        name: "Deactivation Reason",
        width: "160px",
        sortable: true,
        cell: (row) => (
          <div>
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              placement={"top"}
              overlay={
                <Tooltip id={`tooltip-qw`}>{row?.deactivation_reason}</Tooltip>
              }
            >
              <div
                className="text-nowrap text-truncate pr-3"
                style={{ maxWidth: "160px" }}
              >
                {row?.deactivation_reason}
              </div>
            </OverlayTrigger>
          </div>
        ),
        selector: (row) => row?.deactivation_reason,
      },
      {
        name: "FirstName",
        sortable: true,
        cell: (row) => <div>{row?.first_name}</div>,
        selector: (row) => row?.first_name,
      },
      {
        name: "LastName",
        sortable: true,
        cell: (row) => <div>{row?.last_name}</div>,
        selector: (row) => row?.last_name,
      },
      {
        name: "Phone",
        sortable: true,
        cell: (row) => <div>{row?.phone}</div>,
        selector: (row) => row?.phone,
      },
      {
        name: "Email",
        sortable: true,
        cell: (row) => (
          <div>
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              placement={"top"}
              overlay={<Tooltip id={`tooltip-qw`}>{row?.email}</Tooltip>}
            >
              <div
                className="text-nowrap text-truncate pr-3"
                style={{ maxWidth: "116px" }}
              >
                {row?.email}
              </div>
            </OverlayTrigger>
          </div>
        ),
        selector: (row) => row?.email,
      },
    ];

    this.columns1 = [
      {
        name: "IMAGE",
        sortable: true,
        cell: (row) => {
          const alt = this.extractContent(row.light_box_link);
          return (
            <SRLWrapper options={options}>
              <img src={row?.plat} className="img-fluid" alt={alt} />
            </SRLWrapper>
          );
        },
        selector: (row) => row.plat,
      },
      {
        name: "Attempt",
        sortable: true,
        width: "80px",
        cell: (row) => <div>{row?.id}</div>,
        selector: (row) => row?.id,
      },
      {
        name: "Direction",
        sortable: true,
        cell: (row) => (
          <div dangerouslySetInnerHTML={{ __html: row?.entry_or_exit }}></div>
        ),
        selector: (row) => row?.entry_or_exit,
      },
      {
        name: "Result",
        sortable: true,
        cell: (row) => (
          <div dangerouslySetInnerHTML={{ __html: row?.validation }}></div>
        ),
        selector: (row) => row?.validation,
      },
      {
        name: "On",
        sortable: true,
        cell: (row) => <div>{row?.created_at}</div>,
        selector: (row) => row?.created_at,
      },
      {
        name: "Lane",
        sortable: true,
        cell: (row) => <div>{row?.lane_name || "-"}</div>,
        selector: (row) => row?.lane_name,
      },
      {
        name: "Plate",
        sortable: true,
        cell: (row) => <div>{row?.camera_direction}</div>,
        selector: (row) => row?.camera_direction,
      },
      {
        name: "LPN",
        sortable: true,
        cell: (row) => <div>{row?.lpn}</div>,
        selector: (row) => row?.lpn,
      },
    ];
  }

  extractContent(s) {
    const span = document.createElement("span");
    span.innerHTML = s;
    return span.textContent || span.innerText;
  }

  async componentDidMount() {
    const selectedPropertyName = this.state.property?.property_name;
    const selectedDomainName = this.state.property?.domain;
    this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
    if (this.props.location && this.props.location.state) {
      const image = this.props.location.state.image;
      const plateData = this.props.location.state.plateData;
      const scan_time = this.props.location.state.scan_time;
      const isPlateApproved = this.props.location.state.isPlateApproved;
      const lastEntry = this.props.location.state.lastEntry;
      this.setState(
        {
          plate_holder: this.props.location.state.lpn,
          lpn: this.props.location.state.lpn,
          isPlateApproved: isPlateApproved,
          image: image,
          plateData: plateData,
          scan_time: scan_time,
          lastEntry: lastEntry,
        },
        () => {
          this.plateCheck();
        }
      );
    }
  }

  handleChange = (event) => {
    this.setState({
      plate_holder: event.target.value
        .trim()
        .toUpperCase()
        .replace(/[^\w\s]/gi, ""),
      errorMsg: false,
    });
  };

  handleSubmit = () => {
    this.plateCheck();
  };

  plateCheck = () => {
    this.setState({ loader: true }, async () => {
      const {
        page,
        Norow,
        searchValue,
        selectedColumn,
        sort_direction,
        plate_holder,
      } = this.state;
      const pageobj = {
        plate_holder,
        page,
        Norow,
        searchValue,
        selectedColumn,
        sort_direction,
      };
      if (this.state.selectedTab === "Tab1") {
        await this.props.FetchingPlate(pageobj);
        this.setState({
          errorMsg: true,
          loader: false,
          count: this.props.currentPlateSearch.count,
          currentPlateSearch: this.props.currentPlateSearch.data,
          api_response: this.props.api_response,
        });
      } else {
        await this.props.plateFinder(pageobj);
        this.setState({
          errorMsg: true,
          loader: false,
          currentPlate: this.props.currentPlate.data,
          count2: this.props.currentPlate.count,
          api_response: this.props.api_response,
        });
      }
    });
  };

  handleSearchChange = ({ target }) => {
    this.setState({ prevSearchTab2: this.state.searchValue });
    this.setState({ searchValue: target.value }, () => {
      if (!this.state.findMore) {
        if (this.state.searchValue.length) {
          this.setState(
            {
              pageChanged: true,

              searchedPlateList: findBySearch(
                this.state.searchValues,
                this.props.currentPlateSearch.data,
                this.props.currentPlateSearch.data
              ),

              PlateList: findBySearch(
                this.state.searchValue,
                this.props.currentPlate.data,
                this.props.currentPlate.data
              ),
            },
            () => {
              this.setState({
                count: this.state.searchedPlateList.length,
                count2: this.state.PlateList.length,
              });
            }
          );
        } else {
          this.setState({ loader: true, pageChanged: true }, async () => {
            const {
              tab2Page,
              tab2Norow,
              searchValue,
              page,
              Norow,
              searchValues,
              selectedColumn,
              sort_direction,
              plate_holder,
            } = this.state;
            const pageobj = {
              plate_holder,
              page,
              Norow,
              searchValue: searchValues,
              selectedColumn,
              sort_direction,
            };
            const pageobjtab2 = {
              plate_holder,
              page: tab2Page,
              Norow: tab2Norow,
              searchValue,
              selectedColumn,
              sort_direction,
            };
            await this.props.FetchingPlate(pageobj);
            await this.props.plateFinder(pageobjtab2);
            this.setState({
              pageChanged: true,
              page: 1,
              searchedPlateList: this.props.currentPlateSearch.data,
              PlateList: this.props.currentPlate.data,
              loader: false,
            });
          });
          setTimeout(() => {
            this.setState({ findMore: false });
          }, 1500);
        }
      }
    });
  };

  handleSearchChanges = ({ target }) => {
    this.setState({ prevSearch: this.state.searchValues });
    this.setState({ searchValues: target.value }, () => {
      if (!this.state.findMore) {
        if (this.state.searchValues.length) {
          this.setState(
            {
              pageChanged: true,
              searchedPlateList: findBySearch(
                this.state.searchValues,
                this.props.currentPlateSearch.data,
                this.props.currentPlateSearch.data
              ),
              PlateList: findBySearch(
                this.state.searchValue,
                this.props.currentPlate.data,
                this.props.currentPlate.data
              ),
            },
            () => {
              this.setState({
                count: this.state.searchedPlateList.length,
                count2: this.state.PlateList.length,
              });
            }
          );
        } else {
          this.setState({ loader: true, pageChanged: true }, async () => {
            const {
              tab2Page,
              tab2Norow,
              searchValue,
              page,
              Norow,
              searchValues,
              selectedColumn,
              sort_direction,
              plate_holder,
            } = this.state;
            const pageobj = {
              plate_holder,
              page,
              Norow,
              searchValue: searchValues,
              selectedColumn,
              sort_direction,
            };
            const pageobjtab2 = {
              plate_holder,
              page: tab2Page,
              Norow: tab2Norow,
              searchValue,
              selectedColumn,
              sort_direction,
            };
            await this.props.FetchingPlate(pageobj);
            await this.props.plateFinder(pageobjtab2);
            this.setState({
              pageChanged: true,
              page: 1,
              searchedPlateList: this.props.currentPlateSearch.data,
              PlateList: this.props.currentPlate.data,
              loader: false,
            });
          });
          setTimeout(() => {
            this.setState({ findMore: false });
          }, 1500);
        }
      }
    });
  };

  handlepage = ({ target }) => {
    if (this.state.selectedTab !== "Tab2") {
      this.setState({ prevPage: this.state.page, prevNorow: this.state.Norow });
      this.setState({ [target.name]: target.value }, async () => {
        switch (target.name) {
          case "page":
            this.setState({ page: target.value }, async () => {
              const {
                page,
                Norow,
                searchValues,
                selectedColumn,
                sort_direction,
                plate_holder,
              } = this.state;
              const pageobj = {
                page,
                Norow,
                searchValue: searchValues,
                selectedColumn,
                sort_direction,
                plate_holder,
              };
              this.setState({ loader: true, pageChanged: true }, async () => {
                await this.props.FetchingPlate(pageobj);
                this.setState({
                  searchedPlateList: await this.props.currentPlateSearch.data,
                  api_response: this.props.api_response,
                });
                this.setState({ loader: false });
              });
            });
            break;
          case "Norow":
            this.setState({ Norow: target.value }, async () => {
              const {
                page,
                Norow,
                searchValues,
                selectedColumn,
                sort_direction,
                plate_holder,
              } = this.state;
              const pageobj = {
                page,
                Norow,
                searchValue: searchValues,
                selectedColumn,
                sort_direction,
                plate_holder,
              };
              this.setState({ loader: true, pageChanged: true }, async () => {
                await this.props.FetchingPlate(pageobj);
                this.setState({
                  searchedPlateList: await this.props.currentPlateSearch.data,
                  api_response: this.props.api_response,
                });
                this.setState({ loader: false });
              });
            });
            break;
        }
        if (
          Number(this.state.page) !== Number(this.state.prevPage) ||
          Number(this.state.Norow) !== Number(this.state.prevNorow)
        ) {
          const {
            page,
            Norow,
            searchValues,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobj = {
            page,
            Norow,
            searchValue: searchValues,
            selectedColumn,
            sort_direction,
            plate_holder,
          };
          this.setState({ loader: true, pageChanged: true }, async () => {
            await this.props.FetchingPlate(pageobj);
            this.setState({
              searchedPlateList: await this.props.currentPlateSearch.data,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        }
      });
    } else {
      this.setState({
        prevPageTab2: this.state.tab2Page,
        prevNorowTab2: this.state.tab2Norow,
      });
      let targetName;
      if (target.name === "Norow") {
        targetName = "tab2Norow";
      } else {
        targetName = "tab2Page";
      }
      this.setState({ [targetName]: target.value }, async () => {
        switch (targetName) {
          case "tab2Page":
            this.setState({ tab2Page: target.value }, async () => {
              const {
                tab2Page,
                tab2Norow,
                searchValue,
                selectedColumn,
                sort_direction,
                plate_holder,
              } = this.state;
              const pageobjTab2 = {
                page: tab2Page,
                Norow: tab2Norow,
                searchValue,
                selectedColumn,
                sort_direction,
                plate_holder,
              };
              this.setState({ loader: true, pageChanged: true }, async () => {
                await this.props.plateFinder(pageobjTab2);
                this.setState({
                  PlateList: await this.props.currentPlate.data,
                  api_response: this.props.api_response,
                });
                this.setState({ loader: false });
              });
            });
            break;
          case "tab2Norow":
            this.setState({ tab2Norow: target.value }, async () => {
              const {
                tab2Page,
                tab2Norow,
                searchValue,
                selectedColumn,
                sort_direction,
                plate_holder,
              } = this.state;
              const pageobjTab2 = {
                page: tab2Page,
                Norow: tab2Norow,
                searchValue,
                selectedColumn,
                sort_direction,
                plate_holder,
              };
              this.setState({ loader: true, pageChanged: true }, async () => {
                await this.props.plateFinder(pageobjTab2);
                this.setState({
                  PlateList: await this.props.currentPlate.data,
                  api_response: this.props.api_response,
                });
                this.setState({ loader: false });
              });
            });
            break;
        }
        if (
          Number(this.state.tab2Page) !== Number(this.state.prevPageTab2) ||
          Number(this.state.tab2Norow) !== Number(this.state.prevNorowTab2)
        ) {
          const {
            tab2Page,
            tab2Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobjTab2 = {
            page: tab2Page,
            Norow: tab2Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          };
          this.setState({ loader: true, pageChanged: true }, async () => {
            await this.props.plateFinder(pageobjTab2);
            this.setState({
              PlateList: await this.props.currentPlate.data,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        }
      });
    }
  };

  handlepagenext = async () => {
    if (this.state.selectedTab !== "Tab2") {
      const { page, Norow } = this.state;
      const count = await this.props.currentPlateSearch.count;
      const finalPage = Math.ceil(count / Norow);
      if (page + 1 <= finalPage) {
        this.setState({ page: page + 1 }, async () => {
          const {
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobj = {
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          };
          this.setState({ loader: true, pageChanged: true }, async () => {
            await this.props.FetchingPlate(pageobj);
            this.setState({
              searchedPlateList: await this.props.currentPlateSearch.data,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        });
      }
    } else {
      const { tab2Page, tab2Norow } = this.state;
      const count = await this.props.currentPlate.count;
      const finalPage = Math.ceil(count / tab2Norow);
      if (tab2Page + 1 <= finalPage) {
        console.log("nextpage click");
        this.setState({ tab2Page: tab2Page + 1 }, async () => {
          const {
            tab2Page,
            tab2Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobjTab2 = {
            page: tab2Page,
            Norow: tab2Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          };
          this.setState({ loader: true, pageChanged: true }, async () => {
            await this.props.plateFinder(pageobjTab2);
            this.setState({
              PlateList: await this.props.currentPlate.data,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        });
      }
    }
  };

  handlepageprevious = () => {
    if (this.state.selectedTab !== "Tab2") {
      const { page } = this.state;
      if (page !== 1) {
        this.setState({ page: page - 1, pageChanged: true }, async () => {
          const {
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobj = {
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          };
          this.setState({ loader: true }, async () => {
            await this.props.FetchingPlate(pageobj);
            this.setState({
              searchedPlateList: await this.props.currentPlateSearch.data,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        });
      }
    } else {
      const { tab2Page } = this.state;
      if (tab2Page !== 1) {
        this.setState(
          { tab2Page: tab2Page - 1, pageChanged: true },
          async () => {
            const {
              tab2Page,
              tab2Norow,
              searchValue,
              selectedColumn,
              sort_direction,
              plate_holder,
            } = this.state;
            const pageobjTab2 = {
              page: tab2Page,
              Norow: tab2Norow,
              searchValue,
              selectedColumn,
              sort_direction,
              plate_holder,
            };
            this.setState({ loader: true }, async () => {
              await this.props.plateFinder(pageobjTab2);
              this.setState({
                PlateList: await this.props.currentPlate.data,
                api_response: this.props.api_response,
              });
              this.setState({ loader: false });
            });
          }
        );
      }
    }
  };

  handlepageinitial = () => {
    if (this.state.selectedTab !== "Tab2") {
      if (this.state.page !== 1) {
        this.setState({ page: 1, pageChanged: true }, async () => {
          const {
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobj = {
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          };
          this.setState({ loader: true }, async () => {
            await this.props.FetchingPlate(pageobj);
            this.setState({
              searchedPlateList: await this.props.currentPlateSearch.data,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        });
      }
    } else {
      if (this.state.tab2Page !== 1) {
        this.setState({ tab2Page: 1, pageChanged: true }, async () => {
          const {
            tab2Page,
            tab2Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobjTab2 = {
            page: tab2Page,
            Norow: tab2Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          };
          this.setState({ loader: true }, async () => {
            await this.props.plateFinder(pageobjTab2);
            this.setState({
              PlateList: await this.props.currentPlate.data,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        });
      }
    }
  };

  handlepagefinal = async () => {
    console.log("nextpagefinal click");

    if (this.state.selectedTab !== "Tab2") {
      const { page, Norow } = this.state;
      const count = await this.props.currentPlate.count;
      const last_page = count / Norow;
      const rounded = Math.ceil(last_page);
      if (page <= rounded) {
        this.setState({ page: rounded }, () => {
          const {
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobj = {
            page,
            Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          };
          this.setState({ loader: true, pageChanged: true }, async () => {
            await this.props.FetchingPlate(pageobj);
            this.setState({
              searchedPlateList: await this.props.currentPlateSearch.data,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        });
      }
    } else {
      const { tab2Page, tab2Norow } = this.state;
      const count = await this.props.currentPlate.count;
      const last_page = count / tab2Norow;
      const rounded = Math.ceil(last_page);
      if (tab2Page <= rounded) {
        this.setState({ tab2Page: rounded }, () => {
          const {
            tab2Page,
            tab2Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobjTab2 = {
            page: tab2Page,
            Norow: tab2Norow,
            searchValue,
            selectedColumn,
            sort_direction,
            plate_holder,
          };
          this.setState({ loader: true, pageChanged: true }, async () => {
            await this.props.plateFinder(pageobjTab2);
            this.setState({
              PlateList: await this.props.currentPlate.data,
              api_response: this.props.api_response,
            });
            this.setState({ loader: false });
          });
        });
      }
    }
  };

  handleTab = (key) => {
    console.log(key);
    let tabNo;
    if (key === "lpn") {
      tabNo = "Tab2";
    } else if (key === "permit") {
      tabNo = "Tab1";
    }
    this.plateCheck();
    this.setState({ selectedTab: tabNo, ariaSelectedA: true });
  };

  handleTab2 = () => {
    this.setState({ selectedTab: "Tab1" });
  };

  findMorePressed = () => {
    this.setState({ findMore: true }, () => {
      if (this.state.findMore) {
        this.setState({ loader: true, pageChanged: true }, async () => {
          const {
            tab2Page,
            tab2Norow,
            searchValue,
            page,
            Norow,
            searchValues,
            selectedColumn,
            sort_direction,
            plate_holder,
          } = this.state;
          const pageobj = {
            plate_holder,
            page,
            Norow,
            searchValue: searchValues,
            selectedColumn,
            sort_direction,
          };
          const pageobjtab2 = {
            plate_holder,
            page: tab2Page,
            Norow: tab2Norow,
            searchValue,
            selectedColumn,
            sort_direction,
          };
          await this.props.FetchingPlate(pageobj);
          await this.props.plateFinder(pageobjtab2);
          this.setState({
            pageChanged: true,
            page: 1,
            searchedPlateList: this.props.currentPlateSearch.data,
            PlateList: this.props.currentPlate.data,
            loader: false,
          });
        });
        setTimeout(() => {
          this.setState({ findMore: false });
        }, 1500);
      }
    });
  };

  redirectToPlatecheck = () => {
    const history = require("../../history").default;
    if (this.props.location.search === "?audit-report") {
      history.push({
        pathname: `/audit-report`,
      });
    } else if (this.props.location.search === "?verify") {
      history.push({
        pathname: `/plate-check`,
        state: {
          lpn: this.state.lpn,
          isPlateApproved: this.state.isPlateApproved,
          image: this.state.image,
          plateData: this.state.plateData,
          scan_time: this.state.scan_time,
          lastEntry: this.state.lastEntry,
        },
      });
    }
  };

  render() {
    const {
      plate_holder,
      loader,
      // errorMsg,
      searchValues,
      currentPlateSearch,
      searchedPlateList,
      page,
      Norow,
      pageChanged,
      // api_response,
      searchValue,
      PlateList,
      currentPlate,
      tab2Page,
      tab2Norow,
    } = this.state;
    return (
      <div>
        <Container fluid>
          <Row>
            <Col md="12">
              <Card>
                <Card.Header style={{ backgroundColor: this.props.main_body }}>
                  <Card.Title as="h4">
                    <i
                      style={{ marginRight: 5, cursor: "pointer" }}
                      className="fa fa-arrow-left"
                      onClick={this.redirectToPlatecheck}
                      aria-hidden="true"
                    ></i>
                    <span> Plate Audit</span>
                  </Card.Title>
                  <p className="card-category">License Plate Audit history.</p>
                </Card.Header>
                <Card.Body className="pos-rel-overflow-hide">
                  <Row>
                    <Col md="6" lg="4" xs="8" sm="6">
                      <Form.Group>
                        <label>Enter License Plate Number </label>
                        <FormControl
                          type="text"
                          name="plate_holder"
                          value={plate_holder}
                          onChange={this.handleChange}
                          autoComplete="off"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="4" lg="4" xs="4" sm="4" className="pl-0">
                      <Form.Group>
                        <label>&nbsp;</label>
                        <div>
                          <Button
                            className="btn-fill h-40 font-button text-nowrap"
                            onClick={this.handleSubmit}
                            disabled={!plate_holder.trim().length}
                          >
                            Plate Check
                          </Button>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="">
                    <Tabs
                      defaultActiveKey="permit"
                      id="controlled-tab-example"
                      onSelect={this.handleTab}
                    >
                      <Tab eventKey="permit" title="Permit" className="m-0">
                        {loader ? (
                          <Loader />
                        ) : (
                          <div>
                            <DataTable
                              data={
                                searchValues.length || pageChanged
                                  ? searchedPlateList
                                  : currentPlateSearch
                              }
                              columns={this.columns2}
                              customStyles={this.customStyles}
                              // pagination={true}
                              paginationServer={true}
                              responsive={true}
                              // sortServer={true}
                              // onSort={handleonsort}
                              // subHeader
                              subHeaderComponent={
                                <>
                                  <DatatableHeader
                                    searchValue={searchValues}
                                    HandleChange={this.handleSearchChanges}
                                    findMorePressed={this.findMorePressed}
                                  />
                                  {/* <Button onClick={this.findMorePressed}>
                                    Get All Result for {searchValues}
                                  </Button> */}
                                </>
                              }
                              defaultSortAsc={true}
                              fixedHeader={true}
                              fixedHeaderScrollHeight="40vh"
                            />
                            <PaginationforData
                              count={this.state.count}
                              data={this.state.currentPlateSearch}
                              handlepageinitial={this.handlepageinitial}
                              handlepageprevious={this.handlepageprevious}
                              handlepagenext={this.handlepagenext}
                              handlepagefinal={this.handlepagefinal}
                              handlepage={this.handlepage}
                              page={page}
                              Norow={Norow}
                              pageChanged={pageChanged}
                            />
                          </div>
                        )}
                      </Tab>
                      <Tab eventKey="lpn" title="LPR">
                        <>
                          {loader ? (
                            <Loader />
                          ) : (
                            <div>
                              <DataTable
                                data={
                                  searchValue.length || pageChanged
                                    ? PlateList
                                    : currentPlate
                                }
                                columns={this.columns1}
                                customStyles={this.customStyles}
                                // pagination={true}
                                paginationServer={true}
                                // sortServer={true}
                                // onSort={handleonsort}
                                responsive={true}
                                // subHeader
                                subHeaderComponent={
                                  <>
                                    <DatatableHeader
                                      searchValue={searchValue}
                                      HandleChange={this.handleSearchChange}
                                    />
                                    {/* <Button onClick={this.findMorePressed}>
                        Get All Result for {searchValue}
                      </Button> */}
                                  </>
                                }
                                defaultSortAsc={true}
                                fixedHeader={true}
                                fixedHeaderScrollHeight="40vh"
                              />
                              <PaginationforData
                                count={this.state.count2}
                                data={this.state.currentPlate}
                                findMorePressed={this.findMorePressed}
                                handlepageinitial={this.handlepageinitial}
                                handlepageprevious={this.handlepageprevious}
                                handlepagenext={this.handlepagenext}
                                handlepagefinal={this.handlepagefinal}
                                handlepage={this.handlepage}
                                page={tab2Page}
                                Norow={tab2Norow}
                                pageChanged={pageChanged}
                              />
                            </div>
                          )}
                        </>
                      </Tab>
                    </Tabs>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({
  PlateSearchDetails,
  APIResponseDetails,
  UserProfileDetails,
  Logindetails,
}) => {
  const { api_response, api_error_message } = APIResponseDetails;
  const { currentPlate, currentPlateSearch } = PlateSearchDetails;
  const { user_type, timezone, property } = UserProfileDetails;
  const { backgroundColor } = Logindetails;
  const { MainBackground: main_body } = backgroundColor;
  return {
    api_response,
    api_error_message,
    currentPlate,
    currentPlateSearch,
    user_type,
    timezone,
    property,
    main_body,
  };
};

const mapStateToDispatch = {
  plateFinder: PlateSearchActions.plateFinder,
  FetchingPlate: PlateSearchActions.FetchingPlate,
  setDomainHeader: SuperAdminAction.setDomainHeader,
};

export default connect(mapStateToProps, mapStateToDispatch)(CurrentOccupancy);
